import axios from 'axios';
import { API_URL } from "../constantes/constantes";

/**
 * Obtiene los standings del simulador de liguilla
 * Delega a getStanding() para obtener los datos reales de la API
 * @returns {Promise<Object>} Objeto con estructura de standings y código de estado
 */
export async function getSimuladorTeams() {
  // Delegar a getStanding() que ya hace la petición HTTP
  return await getStanding({});
}

/**
 * Obtiene la tabla de posiciones (standings) desde la API
 * @param {Object} options - Opciones
 * @param {string} options.idEvent - ID del evento (opcional)
 * @returns {Promise<Object>} Objeto con los datos de standings y código de estado
 */
export async function getStanding({ idEvent }) {
  let apiURL;
  idEvent = "2hsidwomhjsaaytdy9u5niyi4";
  apiURL = `${API_URL}league/soccer/standing/${idEvent}.json`;

  try {
    // Realizar petición HTTP con configuración de timeout y headers
    const { data, status } = await axios.get(apiURL, {
      timeout: 25000, // 25 segundos de timeout
      headers: {
        'Accept': 'application/json, text/plain, */*'
      }
    });

    return {
      data,
      statusCode: status
    };

  } catch (error) {
    // Manejo de errores con logging y respuesta estructurada
    console.error("Error en getStanding:", error.message || error);

    const statusCode = error.response?.status || 500;

    return {
      statusCode,
      data: { soccerStages: [] } // Estructura vacía como fallback
    };
  }
}

/**
 * Obtiene la tabla de posiciones (standings) de un torneo específico
 * Realiza una petición HTTP a la API real usando la función getStanding()
 * 
 * @param {Object} options - Opciones de la petición
 * @param {string} options.leagueId - ID de la liga (no se usa en getStanding)
 * @param {string} options.tournamentId - ID del torneo (no se usa en getStanding)
 * @param {string} options.stageId - ID del stage/fase (no se usa en getStanding)
 * @returns {Promise<Object>} Objeto con los datos de standings y código de estado
 */
export async function getStandings({ leagueId, tournamentId, stageId } = {}) {
  // Usar la función getStanding() existente que ya hace la petición HTTP real
  return await getStanding({});
}
